import { baseURL } from '..';
import { IDocument } from '../../shared/iDocument';
import httpClient, { IPaginatedResponse, IResponse } from '../httpClient';
import { createHeaders, createRequest, paginationQuery } from '../util';

const documentProvider = () => {

    const getDocumentPreviewsAsync = async (pageNumber?: number, pageSize?: number, filter?: string): Promise<IResponse<IPaginatedResponse<IDocument>>> =>
        httpClient.getAsync(createRequest(baseURL, '/Document/GetPaginatedDocuments', paginationQuery(pageNumber, pageSize, filter)), createHeaders());

    const getAllDocumentAsync = async (pageNumber?: number, pageSize?: number, filter?: string): Promise<IResponse<IDocument[]>> =>
        httpClient.getAsync(createRequest(baseURL, '/Document/GetAllDocuments', paginationQuery(pageNumber, pageSize, filter)), createHeaders());

    const insertDocumentAsync = async (payload: FormData): Promise<IResponse<IPaginatedResponse<IDocument>>> =>
        httpClient.postAsync(createRequest(baseURL, '/Document/insertDocument', undefined, payload), createHeaders('multipart/form-data'));

    const deleteDocumentAsync = async (id: number): Promise<IResponse> => httpClient.deleteAsync(createRequest(baseURL, `/Document/DeleteDocument?id=${id}`), createHeaders());

    const downloadDocumentAsync = async (filename: string, extension: string): Promise<IResponse> =>
        httpClient.getAsync(createRequest(baseURL, `/Document/DownloadDocumentFile/${filename}`), createHeaders(`application/${extension}`));

    return { getDocumentPreviewsAsync, getAllDocumentAsync, deleteDocumentAsync, insertDocumentAsync, downloadDocumentAsync };
};

export default documentProvider();
